import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumb from '../../components/BreadCrumb';
import formatPrice from '../../services/utils/formatPrice';
import { FiFileText } from 'react-icons/fi';
import { MdAttachMoney } from 'react-icons/md';
import { getContractsFromDealOrDebt } from '../../utils/getContractsToShow';
import getOriginalContract from '../../utils/getOriginalContract';
import getContractDescription from '../../utils/getContractDescription';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import ModalContracts from '../../components/Modal/Contracts';
import InvoiceList from '../../components/InvoiceList';
import {
  Wrapper,
  Container2,
  TitleWrapper,
  IconBack,
  Title,
  SubWrapper,
  Subtitle,
  DetailContent,
  Link,
  Subtitle2,
  SkeletonWrapper,
  Button,
} from './styles';
import { navigationUrl } from '../../store/analytic/actions';

type NegotiationProps = {
  contract: GQL.IDebt;
};

const Invoices = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const location = useLocation<NegotiationProps>();
  const dispatch = useDispatch();
  const contract: GQL.IDebt = location.state && location.state.contract;
  const contractsToShow = useMemo(() => getContractsFromDealOrDebt(contract), [
    contract,
  ]);

  const { negotiationLoading, selectedInstallments } = useSelector(
    (state: ApplicationState) => ({
      negotiationLoading: state.negotiation.negotiationLoading,
      selectedInstallments: state.contract.selectedInstallments,
    })
  );

  const handlerOpen = () => {
    setOpen(true);
  };

  const handlerClose = (): void => {
    setOpen(false);
  };

  const handleNavigation = (action: string) => {
    if (action === 'previous') {
      return history.replace('/acordos-debitos');
    }
    history.push({
      pathname: '/métodos-pagamento',
      state: { contract: contract },
    });
  };

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/selecionouFaturas',
      }),
    );
  }, [dispatch])

  return (
    <Wrapper>
      <Container2>
        <TitleWrapper>
          <IconBack onClick={() => history.replace('/acordos-debitos')} />
          <Title>Minhas Faturas</Title>
          <BreadCrumb
            currentPage='Minhas Faturas'
            previouPages={[{ name: 'Débitos e Acordos', route: '/contrato' }]}
            showBreadCrumbOnMinWidth='960px'
          />
        </TitleWrapper>
        <SubWrapper>
          <Subtitle>
            Valor atual da dívida: R${' '}
            {contract && formatPrice(contract.updatedValue)}
          </Subtitle>
          <DetailContent style={{ width: '100%' }}>
            <div className='bank-name'>
              <span>{contract && contract.creditorName}</span>
            </div>
            <div className='default'>
              <FiFileText className='space-right' />
              {contract && contract.contracts.length > 1
                ? `Múltiplos contratos: `
                : `Contrato: `}
              {contract && contract.contracts.length === 1 && (
                <strong className='space-left'>
                  {contractsToShow && getOriginalContract(contractsToShow[0])}
                </strong>
              )}

              <Link onClick={() => handlerOpen()}>
                {'  Detalhar dívida(s)'}
              </Link>
            </div>
            {contract && contract.contracts.length === 1 && (
              <span className='default' style={{ marginBottom: 0 }}>
                {getContractDescription(contractsToShow[0])}
              </span>
            )}
            <div className='default'>
              <MdAttachMoney
                style={{ marginRight: '4px', marginLeft: '-2px' }}
                size={15}
              />
              Valor original da dívida:
              <strong className='space-left'>
                R$ {contract && formatPrice(contract.originalValue)}
              </strong>
            </div>
            <div className='default'>
              O valor atualizado contém juros e encargos sob o original
            </div>
          </DetailContent>
          <Subtitle2>Selecione as faturas para negociar</Subtitle2>
          {negotiationLoading ? (
            <Wrapper>
              <SkeletonWrapper>
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
              </SkeletonWrapper>
            </Wrapper>
          ) : (
            <InvoiceList
              contracts={contractsToShow as GQL.IContractDetails[]}
            />
          )}
        </SubWrapper>
        <div className='footer'>
          <Button color='white' onClick={() => handleNavigation('previous')}>
            Voltar
          </Button>
          <Button
            color='primary'
            onClick={() => handleNavigation('next')}
            disabled={!selectedInstallments?.length}
          >
            Próximo
          </Button>
        </div>
        {open && (
          <ModalContracts
            handlerClose={handlerClose}
            contracts={contractsToShow}
          />
        )}
      </Container2>
    </Wrapper>
  );
};

export default Invoices;
